var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupermarket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Supermarket--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Supermarket Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5a1.25 1.25 0 0 0 -1.25 -1.25h-5.5A0.25 0.25 0 0 1 17 11V9a0.5 0.5 0 0 0 -0.5 -0.5h-9A0.5 0.5 0 0 0 7 9v2a0.25 0.25 0 0 1 -0.25 0.25h-5.5a1.25 1.25 0 0 0 0 2.5h0.5A0.25 0.25 0 0 1 2 14v9.75a0.25 0.25 0 0 0 0.25 0.25h19.5a0.25 0.25 0 0 0 0.25 -0.25V14a0.25 0.25 0 0 1 0.25 -0.25h0.5A1.25 1.25 0 0 0 24 12.5ZM11 22a0.5 0.5 0 0 1 -0.5 0.5H8a0.5 0.5 0 0 1 -0.5 -0.5v-4.5A0.5 0.5 0 0 1 8 17h2.5a0.5 0.5 0 0 1 0.5 0.5Zm-1 -9.5a2 2 0 1 1 2 2 2 2 0 0 1 -2 -2Zm6.5 9.5a0.5 0.5 0 0 1 -0.5 0.5h-2.5a0.5 0.5 0 0 1 -0.5 -0.5v-4.5a0.5 0.5 0 0 1 0.5 -0.5H16a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5h13a1.25 1.25 0 0 0 0 -2.5h-5.25a0.25 0.25 0 0 1 -0.25 -0.25v-1a0.25 0.25 0 0 1 0.25 -0.25h2a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H12a1 1 0 0 0 -1 1v3.75a0.25 0.25 0 0 1 -0.25 0.25H5.5a1.25 1.25 0 0 0 0 2.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupermarket);
export default ForwardRef;